import { sendExpandRequest } from 'reactApp/modules/integration/communicator';
import { getIntegrationState } from 'reactApp/modules/integration/integration.selectors';
import type { IntegrationState } from 'reactApp/modules/integration/integration.types';
import { select } from 'redux-saga/effects';

export function* handleExpandRequest() {
    const { parentOrigin }: IntegrationState = yield select(getIntegrationState);
    sendExpandRequest(parentOrigin);
}
